const OPPORTUNITY_STAGES = {
  CREATED: "1. Created" as const,
  APPOINTMENT_SCHEDULED: "2. Appointment Scheduled" as const,
  INITIAL_APPOINTMENT_COMPLETE: "3. Initial Appointment Complete" as const,
  AGREEMENT_SIGNED: "4. Agreement Signed" as const,
  READY_FOR_SUBMISSION: "5. Ready for Submission" as const,
  SUBMITTED_TO_OPERATIONS: "6. Submitted To Operations" as const,
  CLOSED_WON: "7. Closed Won" as const,
  AT_RISK_CUSTOMER: "8. At-Risk Customer" as const,
  CANCELLED_PROJECT: "9. Cancelled Project" as const,
  INSTALLED_PTO: "10. Installed PTO" as const,
  CLOSED_LOST: "11. Closed Lost" as const,
} as const;

const STAGES_SUBMITTED_TO_CONTRACT_REVIEW: string[] = [
  OPPORTUNITY_STAGES.SUBMITTED_TO_OPERATIONS,
  OPPORTUNITY_STAGES.CLOSED_WON,
  OPPORTUNITY_STAGES.AT_RISK_CUSTOMER,
  OPPORTUNITY_STAGES.CANCELLED_PROJECT,
  OPPORTUNITY_STAGES.INSTALLED_PTO,
];

const hasSubmittedToContractReview = (leadStage?: string): boolean =>
  !!leadStage && STAGES_SUBMITTED_TO_CONTRACT_REVIEW.includes(leadStage);

const PREFERRED_LANGUAGE_OPTIONS = [
  { label: "English", value: "English" },
  { label: "Spanish", value: "Spanish" },
];

/** Mirrors the home type values offered in sales-experience-leads. */
const HOME_TYPE_OPTIONS = [
  {
    label: "Detached single family home",
    value: "Detached single family home",
  },
  { label: "Townhome / rowhome", value: "Townhome / rowhome" },
  { label: "Apartment", value: "Apartment" },
  { label: "Tiny Home", value: "Tiny Home" },
  { label: "Mobile Home", value: "Mobile Home" },
  { label: "Non Residential", value: "Non Residential" },
  { label: "Vertically-split duplex", value: "Vertically-split duplex" },
];

export {
  OPPORTUNITY_STAGES,
  hasSubmittedToContractReview,
  HOME_TYPE_OPTIONS,
  PREFERRED_LANGUAGE_OPTIONS,
};
